import { useDataSelector } from '@uswitch/ev-utils/context/selectors'
import { appendQuery, queryList } from '../../utils/url'

const sameHost = (a, b) => {
  try {
    return a === new URL(b).host
  } catch (e) {
    /**
     * Assume that if anything goes wrong we are on the same host
     * e.g. `/same-host-path`
     * Therefor assume true and don't preserve query params
     */
    return true
  }
}

export const FormHiddenFields = ({ action }) => {
  const { appHost, query } = useDataSelector(['location'])

  const fields = queryList(appendQuery(action, query))

  // Do not add hidden input fields for same domain clickouts
  if (sameHost(appHost, action)) return null

  return (
    <For each='param' of={fields} index='i'>
      <input key={`param-${i}`} type='hidden' name={param.param} value={param.value} />
    </For>
  )
}
